import { computed } from 'vue';
import { defineNuxtPlugin, type NuxtApp } from '#app';
import { createRegistry } from '@devhacker/shared/plugins/registry/createRegistry';
import { authRequestInterceptor } from '~/utils/interceptorsRequestAuth';
import { authErrorHandler } from '~/utils/errorHandlerAuth';
import { useIndexStore } from '~/store';
import type { User } from '@devhacker/shared/features/user/types/user';
import { useTalkerStore } from '@devhacker/shared/plugins/talker/store/talker';
import { normalizeUserData } from '~/libs/normalizeUserData';

export default defineNuxtPlugin((nuxtApp) => {
  const log = (nuxtApp as NuxtApp).$logger.withScope('®️ registry');

  const indexStore = useIndexStore();
  const talkerStore = useTalkerStore();

  const registry = {
    interceptors: {
      authRequest: authRequestInterceptor,
      authError: authErrorHandler,
    },
    auth: {
      changeAfterLoginAction,
      setRefreshTokenPending: (isPending: boolean) => indexStore.setUserRTAction(isPending),
      isAuthenticatedInWordpress: computed(() => indexStore.isAuthenticatedInWordpress),
    },
    user: {
      updateUser,
      patchUser,
    },
  };

  function updateUser(user: User) {
    talkerStore.setUser(normalizeUserData(user));
    indexStore.updateUser(user);
  }

  function patchUser(partialUser: Partial<User>) {
    talkerStore.setUser(normalizeUserData({ ...indexStore.user, ...partialUser }));
    indexStore.patchUser(partialUser);
  }

  function changeAfterLoginAction(action?: (user: User | null) => void) {
    indexStore.afterLoginAction = action ? () => action(indexStore.user) : undefined;
  }

  log('create registry', registry);
  nuxtApp.provide('registry', createRegistry(registry));
});
